import { AnswerItemType } from 'src/model/card'

const addCardPopupData = [
  {
    title: 'Information & <br/> Knowledge',
    type: AnswerItemType.INFORM,
    image: '/assets/card-type-images/add-card-popup/information-knowledge.svg',
    header: 'Standard',
  },
  {
    title: 'AI-powered <br/>Page',
    type: 'page-change-info',
    image: '/assets/card-type-images/add-card-popup/ai-page.svg',
    header: 'AI',
  },
  {
    title: 'One correct <br/>answer',
    type: AnswerItemType.TESTINGSINGLECHOICE,
    image: '/assets/card-type-images/add-card-popup/one-correct-answer.svg',
    header: 'Quiz',
  },
  {
    title: 'Multiple correct <br/>answers',
    type: AnswerItemType.TESTINGMULTIPLECHOICE,
    image:
      '/assets/card-type-images/add-card-popup/multiple-correct-answers.svg',
    header: 'Quiz',
  },
  {
    title: 'AI-powered <br/>quiz',
    type: 'page-change',
    image: '/assets/card-type-images/add-card-popup/ai-quiz.svg',
    header: 'Quiz',
  },
  {
    title: 'Single <br/>choice',
    type: AnswerItemType.SURVEYSINGLECHOICE,
    image: '/assets/card-type-images/add-card-popup/single-choice.svg',
    header: 'Survey',
  },
  {
    title: 'Multiple <br/>choice',
    type: AnswerItemType.SURVEYMULTIPLECHOICE,
    image: '/assets/card-type-images/add-card-popup/multiple-choice.svg',
    header: 'Survey',
  },
  {
    title: 'Open-ended <br/>(long text)',
    type: AnswerItemType.SURVEYFREEFORM,
    image: '/assets/card-type-images/add-card-popup/open-ended.svg',
    header: 'Feedback',
  },
  {
    title: 'Basic input <br/>(short text)',
    type: AnswerItemType.SURVEYINPUT,
    image: '/assets/card-type-images/add-card-popup/basic-input.svg',
    header: 'Feedback',
  },
  {
    title: 'Star <br/>Rating',
    type: AnswerItemType.SURVEYSTARS,
    image: '/assets/card-type-images/add-card-popup/star-rating.svg',
    header: 'Feedback',
  },
  {
    title: 'Numeric <br/>answer',
    type: AnswerItemType.SURVEYNUMERICENTRY,
    image: '/assets/card-type-images/add-card-popup/numeric-answer.svg',
    header: 'Feedback',
  },
  {
    title: 'Password <br/>check',
    type: AnswerItemType.PROTECTIONCARD,
    image: '/assets/card-type-images/add-card-popup/password-card.svg',
    header: 'Gateway',
  },
]

export default addCardPopupData
